var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "profile-page page" }, [
    _c("div", { staticClass: "container-padding" }, [
      _c(
        "div",
        { staticClass: "profile-page__inner" },
        [
          _c(
            "div",
            { staticClass: "profile-page__content" },
            [
              _c("ProfileCardComponent", {
                attrs: {
                  title: _vm.user.name + " " + (_vm.user.surname || ""),
                  phone: _vm.user.phone,
                  email: _vm.user.email,
                  icon: "edit",
                },
              }),
              _c("ProfileCardComponent", {
                attrs: {
                  title: "История заказов",
                  subtitle: _vm._f("plural")(
                    _vm.orders.length,
                    "заказ",
                    "заказа",
                    "заказов"
                  ),
                  icon: "cart",
                  route: { name: "orders" },
                },
              }),
              _c("ProfileCardComponent", {
                attrs: {
                  title: "Избранное",
                  subtitle: _vm._f("plural")(
                    _vm.favorites.length,
                    "товар",
                    "товара",
                    "товаров"
                  ),
                  icon: "heart",
                  route: { name: "favourite" },
                },
              }),
            ],
            1
          ),
          _c("ProfileAsideComponent"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }